import angular from 'angular';

import requestModule from '../estoffice/common/request.module';
import { unitSearchPanel } from './unit.search.panel.directive';
import { UnitSearchPanelFilterService } from './unit.search.panel.filter.service';
import { UnitSearchPanel } from './unit.search.panel.resource';

export default angular
  .module('unit.search.panel', [requestModule.name])
  .directive('unitSearchPanel', unitSearchPanel)
  .service('unit.search.panel.filter', UnitSearchPanelFilterService)
  .factory('UnitSearchPanel', UnitSearchPanel);
